import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosInstance, saveAuthTokens } from "../../utils/axios";
import { useUserContext } from "../../contexts/user";

const DiscordCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser, setLoading } = useUserContext();

  useEffect(() => {
    const handleCallback = async () => {
      setLoading(true);
      const code = searchParams.get("code");

      if (!code) {
        console.error("No code parameter found in URL");
        setLoading(false);
        navigate("/");
        return;
      }

      try {
        const response = await axiosInstance.get(`/auth/discord/callback?code=${code}`);
        const data = response?.data;

        if (data && data.token) {
          // Save token, refresh token, and expiration info
          saveAuthTokens({
            token: data.token,
            expires: data.expires,
            refreshToken: data.refreshToken,
            refreshTokenExpires: data.refreshTokenExpires,
          });
          setLoading(false);

          // Refresh user info for the rest of the app
          refreshUser();

          if (data.driverId) {
            // Navigate to driver profile
            navigate(`/drivers/${data.driverId}`);
          } else {
            navigate(`/`);
          }
        } else {
          console.error("Invalid response from callback endpoint");
          setLoading(false);
          navigate("/");
        }
      } catch (error) {
        console.error("Failed to complete Discord authentication:", error);
        setLoading(false);
        navigate("/");
      }
    };

    handleCallback();
  }, [searchParams, navigate, setLoading, refreshUser]);

  return null;
};

export default DiscordCallback;
